import type { ExportMetadata } from "@impero-com/common/utils/export";
import { getOrgCookie } from "@impero-com/common/utils/orgCookie";

import { getOrgProfileCookie } from "./profileCookie";

export function newExportMetadata(): ExportMetadata {
    const orgCookie = getOrgCookie();
    const orgProfileCookie = getOrgProfileCookie()!;
    return {
        date: new Date(),
        organization: {
            name: orgCookie.name,
        },
        user: {
            firstName: orgProfileCookie.firstName,
            lastName: orgProfileCookie.lastName,
            email: orgProfileCookie.email,
        },
    };
}
